/* Quinton · rediseño: mensaje de WhatsApp del carrito armado al hacer clic (antes salía "Total: $0,00"). */
(function () {
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-AR'); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-qt-wa-cart]');
    if (!a) return;
    e.preventDefault();
    var win = window.open('', '_blank');
    var base = a.href.split('?')[0];
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items.map(function (i) { return '- ' + i.product_title + ' x' + i.quantity + ' (' + money(i.final_line_price) + ')'; });
        var txt = '¡Hola! Quiero comprar:\n' + lines.join('\n') + '\nTotal: ' + money(cart.total_price) + '. ¿Cómo coordino el pago y el envío?';
        var url = base + '?text=' + encodeURIComponent(txt);
        if (win) win.location = url; else location.href = url;
      })
      .catch(function () { if (win) win.location = a.href; else location.href = a.href; });
  });
})();

/* Reseñas de Judge.me: ordenar siempre por mayor calificación al cargar. */
(function () {
  var tries = 0;
  var t = setInterval(function () {
    var s = document.querySelector('.jdgm-sort-dropdown');
    if (++tries > 40) return clearInterval(t);
    if (!s || s.dataset.qtSorted) return;
    s.dataset.qtSorted = '1';
    clearInterval(t);
    if (s.value !== 'highest_rating') {
      s.value = 'highest_rating';
      s.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, 250);
})();
